<template lang='pug' src='./orthodontics.pug'></template>

<script>
import Adult from 'components/custom/custom-ortho-adult/custom-ortho-adult'
import Braces from 'components/custom/custom-ortho-braces/custom-ortho-braces'
import Children from 'components/custom/custom-ortho-children/custom-ortho-children'
import Emergency from 'components/custom/custom-ortho-emergency/custom-ortho-emergency'
import FAQ from 'components/custom/custom-ortho-faq/custom-ortho-faq'
import Food from 'components/custom/custom-ortho-foods/custom-ortho-foods'
import Hero from 'components/hero/hero-pages/hero-pages'
import Invisalign from 'components/custom/custom-ortho-invisalign/custom-ortho-invisalign'
import Loader from 'components/loader/loader'
import Teen from 'components/custom/custom-ortho-teen/custom-ortho-teen'
import Tmj from 'components/custom/custom-ortho-tmj/custom-ortho-tmj'

export default {
  name: 'orthodontics',
  computed: {
    props () {
      return this.$store.state.pages['orthodontics']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Adult,
    Braces,
    Children,
    Emergency,
    FAQ,
    Food,
    Hero,
    Invisalign,
    Loader,
    Teen,
    Tmj
  }
}
</script>



// WEBPACK FOOTER //
// orthodontics.vue?a8167988